<template>
  <div class="gobal-message-letter-con" :class="isHidden && 'hide'">
    <img :src="require('@/assets/images/workspace/message-letter.png')" class="tips-img" />
    <span @click="handleClose" class="close-msg iconfont iconclose"></span>

    <h1 class="msg-title">{{detail.subclass_name}}</h1>
    <div class="content-con">
      <div v-html="getHtml()"></div>
      
      <div class="btn-con" v-if="detail.subclass == 715 || detail.subclass == 716 || detail.subclass == 717 || detail.subclass == 718|| detail.subclass == 719 || detail.subclass == 720 || detail.subclass == 721 || detail.subclass == 710 || detail.subclass == 711 || detail.subclass == 712 || detail.subclass == 713 || detail.subclass == 714">
        <button  class="smart-btn" v-if="detail.subclass == 715 || detail.subclass == 719" @click="handleDetail">召唤经纪人跟进客户</button>
        <button  class="smart-btn" v-if="detail.subclass == 716 || detail.subclass == 718" @click="handleDetail">更新新客池客设置</button>
        <button  class="smart-btn" v-if="detail.subclass == 717" @click="handleDetail">立即抢</button>
        <button  class="smart-btn" v-if="detail.subclass == 720 || detail.subclass == 721 || detail.subclass == 710 || detail.subclass == 711 || detail.subclass == 712 ||  detail.subclass == 713 ||  detail.subclass == 714" @click="handleDetail">立即查看</button>
      </div>
      <div class="btn-con" v-else>
        <el-button size="small" @click="handleClose">知道了</el-button>
        <el-button size="small" class="global-btn primary" @click="handleDetail">查看明细</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import {getXiaoyunRealtimeMsg} from '@/api/workspace';
import {getMessageList} from '@/api/base';

import {getToken} from '@/utils/auth';
import messageMixins from '@/mixins/messageMixins';
export default{
  name: 'MessageLetters',
  mixins: [messageMixins],
  data () {
    return {
      detail: {},
      isHidden: true,
      list:[],
    }
  },
  created() {
    //this.initList()
    this.loop();
  },
  methods: {
    // 已经登录的前提下1分钟轮询
    loop () {
      setTimeout(() => {
        this.loop();
      }, 1000 * 60);
      this.initRealTimeMsg();
    },
    async initRealTimeMsg () {
      if (!getToken()) return null;
      try {
        const res = await getXiaoyunRealtimeMsg();
        if (res.subclass) {
          this.detail = res;
          this.isHidden = false;
        } else {
          this.isHidden = true;
        }
      } catch (error) {
        this.isHidden = true;
      }
    },
    async initList () {
      this.isLoading = true;
      try {
        const res = await getMessageList({
          category: 7,
          per_page:100,
          page: 1,
          total: 0
        });
        this.list = res.data || [];
        this.detail = this.list[39]
      
      } catch (error) {
        this.$message.error(error.msg || '操作失败，请重试');
      } finally {
        this.isLoading = false;
      }
    },
    handleClose () {
      this.isHidden = true;
      setTimeout(() => {
        this.detail = {};
      }, 500);

    },
    // 手动拼接小云消息
    getHtml () {
      const xiaoyunMsgList = this.generateXiaoyu(this.detail);
      var subclass = this.detail.subclass
      if (xiaoyunMsgList.length > 0) {
        return xiaoyunMsgList.map((v, i) => {
          // 400 消息单独处理
          if (subclass == 703) {
            return i > 0 && i < xiaoyunMsgList.length - 1 ? `<p class="msg-item-tips">${v}</p>` : `<p class="msg-item">${v}</p>`;
          }

          if(subclass == 711 || subclass == 713 || subclass == 712 || subclass == 714 || subclass == 715 || subclass == 716 || subclass == 717 || subclass == 718|| subclass == 719 || subclass == 721 || subclass == 710 ){
            return `<p class="msg-item has-time">${v}</p>`;
          }
          if(subclass == 710){
            return `<p class="msg-item msg-line has-time">${v}</p>`;
          }else if(subclass == 720){
            return `<p class="msg-item msg-line line_720 has-time">${v}</p>`;
          }else{
            return `<p class="msg-item">${v}</p>`;

          }

        }).join('');
      }
    },
    // 查看小云消息详情
    async handleDetail () {
      this.handleXiaoyuRedirect(this.detail);
      // 关闭消息弹层
      this.handleClose();
    }
  },
}
</script>
<style lang="less" scope>
.close-msg{
  position: absolute;
  right: 30px;
  top: 20px;
  font-size: 30px;
  color: #fff;
  cursor: pointer;
}
@import url('~@/assets/style/workspace/messageLetter.less');
</style>